module.exports = __webpack_public_path__ + "static/media/logo-rma.54a218c6.png";